import { classNames } from 'primereact/utils';

import TasksTabView from './components/tasks-tab-view/TasksTabView';
import styles from './TasksPage.module.css';

const TasksPage = (): JSX.Element => {
  return (
    <div className={classNames('px-3 py-4 sm:p-4 flex flex-column', styles.tasksPage)}>
      <TasksTabView />
    </div>
  );
};

export default TasksPage;
